import React, { useState, Component, Fragment } from 'react';
import { Provider } from 'react-redux';
import 'babel-polyfill';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DesignStatus from '../../common/components/DesignStatus/DesignStatus';
import createStore from '../../customer_chat/store/createStore';
import Chat from '../../customer_chat/containers/ChatContainer';
import SvgIcon from '../../common/SvgIcon';
import request from '../../common/utils/request';
import { MOOD_PLACEHOLDER } from '../../design/routes/Moodboard/modules/moodboard-drag-and-drop';
import { isConsultancy } from '../customer/brief/utils/projectStatusForCustomer';
import workInProgressImg from "../customer_projects_list/work_in_progress.jpg";

export default function DesignerProjectsList({ projectsByCustomer: projectsByCustomerInitial }) {
  const [projectsByCustomer, setProjectsByCustomer] = useState(projectsByCustomerInitial);
  console.log(projectsByCustomerInitial);
  function getChatStore(chat) {
    const initialStore = {
      chat: {
        messages: [],
        message: {
          images: [],
          files: [],
        },
        ...chat,
      },
    };
    return createStore(initialStore);
  }

  const projectApproved = project => project.status === 'approved';

  const projectMoreTimeApproved = project => project.additional_hours_status === 'approved';

  const projectArchivedForCustomer = project => project.status === 'archived';

  const categoryReleasedForCustomer = project =>
    project.category_release_status === 'approved' && project.status === 'in_progress';

  const projectInProgress = project =>
    project.status === 'in_progress' || project.status === 'awaiting';

  const projectOnboarding = project => project.status === 'onboarding';

  const projectOnPause = project => project.status === 'on_pause';

  const renderImage = project => (
    <div className="image -fourxthree">
      {project.images[0] && <img className="image_body" src={project.images[0].thumb} alt="" />}
    </div>
  );

  const renderProjectCompleted = project => renderImage(project);

  const renderProjectOnPause = project => {
    if (project.images.length > 0) {
      return renderImage(project);
    }

    return (
      <div className="text-with-icon">
        <div className="text-with-icon_inner">
          <div className="status-icon">
            <svg className="">
              <use xlinkHref="#project-on-pause" xmlnsXlink="http://www.w3.org/1999/xlink" />
            </svg>
          </div>
        </div>
      </div>
    );
  };

  const renderProjectInProgress = project => {
    if (project.images.length > 0) {
      return renderImage(project);
    }
    return (
      <div className="image -fourxthree">
        <img className="image_body" src={workInProgressImg} alt=""/>
      </div>
    );
  };

  const renderCategoryReleasedForCustomer = project => {
    if (project.images.length > 0) {
      return renderImage(project);
    }
    return (
      <div className="image -fourxthree">
        <img className="image_body" src={workInProgressImg} alt=""/>
      </div>
    );
  };

  const renderProjectOnboarding = () => (
    <div className="text-with-icon">
      <div className="text-with-icon_inner">
        <div className="status-icon">
          <svg className="">
            <use xlinkHref="#project-onboarding" xmlnsXlink="http://www.w3.org/1999/xlink" />
          </svg>
        </div>
      </div>
    </div>
  );

  const renderProjectImage = project => {
    if (projectOnPause(project)) {
      return renderProjectOnPause(project);
    }
    if (projectApproved(project)) {
      return renderProjectCompleted(project);
    }
    if (projectArchivedForCustomer(project)) {
      return renderProjectCompleted(project);
    }
    if (categoryReleasedForCustomer(project)) {
      return renderCategoryReleasedForCustomer(project);
    }
    if (projectOnboarding(project)) {
      return renderProjectOnboarding(project);
    }
    return renderProjectInProgress(project);
  };

  const renderStatusDescription = project => {
    if (projectOnboarding(project)) {
      return (
        <div className="project-preview_attention">
          <div className="project-preview_attention_title">
            Stage 2 of the brief is not completed.
          </div>
          <div>
            We need additional details to match you with a designer and start the design process.
          </div>
        </div>
      );
    }

    if (categoryReleasedForCustomer(project)) {
      return (
        <div className="project-preview_attention -green">
          <div className="project-preview_attention_title">
            Design in progress: Categories released to customer!
          </div>
        </div>
      );
    }

    if (projectApproved(project)) {
      if (isConsultancy(project)) {
        return (
          <div className="project-preview_attention -green">
            <div className="project-preview_attention_title">Consultancy complete.</div>
            <div>
              The customer has &nbsp;
              <b> {project.days_before_archived} days</b>
              to ask your questions before the design is archived.
            </div>
            <div className="">
              Hours bought: {project.hours_purchased}
              <br />
              Hours complete: {project.hours_used}
            </div>
          </div>
        );
      }
      return (
        <div className="project-preview_attention -green">
          <div className="project-preview_attention_title">Design issued to customer.</div>
          <div>
            The customer has &nbsp;
            <b> {project.days_before_archived} days </b>
            to ask your questions before the design is archived.
          </div>
        </div>
      );
    }

    if (projectInProgress(project)) {
      if (projectMoreTimeApproved(project)) {
        return (
          <div className="project-preview_attention -red">
            <div className="project-preview_attention_title">
              <SvgIcon icon="icon-more-hours" />
              {isConsultancy(project)
                ? 'More Consultancy hours added.'
                : 'Design issued but more hours added.'}
            </div>
            <div> Let head off know when you're done and we will archive the project. </div>
          </div>
        );
      }

      return (
        <div className="project-preview_attention -green">
          <div className="project-preview_attention_title">
            Design in progress: please update the timeline as you go.
          </div>
        </div>
      );
    }

    return null;
  };

  const navigateProject = project => {
    window.open(`/design/projects/${project.id}`);
  };

  const removeProjectFromList = (project, customerId) => {
    const customerIdx = projectsByCustomer.findIndex(
      customerI => customerI.customer.id === customerId,
    );
    const customerProjects = projectsByCustomer[customerIdx];
    const index = customerProjects.projects.findIndex(projectI => projectI === project);
    if (index !== -1) {
      customerProjects.projects.splice(index, 1);
    }
    if (customerProjects.projects.length === 0) {
      projectsByCustomer.splice(customerIdx, 1);
    }
    setProjectsByCustomer([...projectsByCustomer]);
  };

  const archiveProject = (project, customerId) => {
    const msg = 'Do you really want to ARCHIVE this project?';
    const confirmation = confirm(msg);
    if (confirmation) {
      request('post', `/design/projects/${project.id}/archive.json`, {})
        .then(() => {
          removeProjectFromList(project, customerId);
        })
        .catch(() => {
          alert('Something went wrong. Please, try again.');
        });
    }
    return false;
  };

  const onArchiveProjectClick = (project, customerId) => event => {
    event.preventDefault();
    event.stopPropagation();
    archiveProject(project, customerId);
  };

  return (
    <div className="designer-projects-list">
      {projectsByCustomer.length === 0 && (
        <div className="designer-projects-list-items">
          <div className="designer-projects-list_item -nothing-found">
            <div>You have no designs yet.</div>
          {/*  add a book free call */}
          </div>
        </div>
      )}
      {projectsByCustomer.map(projectsByCustomerItem => (
        <Fragment key={projectsByCustomerItem.customer.id}>
          <div className="designer-projects-list_customer-info">
            <div className="designer-projects-list_customer-info_chat">
              <Provider store={getChatStore(projectsByCustomerItem.chat)}>
                <Chat />
              </Provider>
            </div>
            <div className="designer-projects-list_customer-info_name">
              {projectsByCustomerItem.customer.full_name}
            </div>
          </div>
          <div className="designer-projects-list-items">
            {projectsByCustomerItem.projects.map(project => (
              <div className="designer-projects-list_item" key={project.id}>
                <a className="project-preview" onClick={() => navigateProject(project)}>
                  <div className="project-preview_photo-wrapper">
                    {renderProjectImage(project)}
                    {project.term === 'express' && (
                      <div className={cn('designer-projects-preview_status -urgent -bottom')}>
                        Express Design
                      </div>
                    )}
                  </div>
                  <div className="project-preview_info-wrapper">
                    <h2 className="project-preview_design-status_wrappertitle">
                      {project.headline || project.room_type_text}
                    </h2>
                    <h2 className="project-preview_sub-title">{project.status_info}</h2>
                  </div>
                  {project.can_archive && (
                    <button
                      type="button"
                      className="project-preview_unarchive"
                      data-tooltip="Archive Project"
                      onClick={onArchiveProjectClick(project, projectsByCustomerItem.customer.id)}
                    >
                      <SvgIcon icon="icon-archive" />
                    </button>
                  )}
                </a>
                <div className="designer-projects-list_item_info">
                  {renderStatusDescription(project)}
                  {isConsultancy(project) ? null : (
                    <DesignStatus
                      project={project}
                      editable={false}
                      info={false}
                      statusHeader={false}
                      className="-inline"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </Fragment>
      ))}
    </div>
  );
}

DesignerProjectsList.propTypes = {
  projectsByCustomer: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};



// WEBPACK FOOTER //
// ./app/javascript/components/designer_projects_list/index.js